import { Button, Typography, Box, Link } from '@mui/material';

import Grid from 'components/core/Grid';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import { ContentSection, CircleBullet } from './styles';

export const ClaimPerkSteps = ({ openModal }: { openModal: () => void }) => {
  const onClick = () => {
    openModal();
  };
  return (
    <>
      <ContentSection>
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Box mb={2}>
              <Typography variant="h3" mt={4} mb={1}>
                <CircleBullet>1</CircleBullet> Be a season pass holder
              </Typography>
              <Typography>Purchase your Winter season pass from BigWhite.com as early as possible.</Typography>
            </Box>
            <Button target="_blank" href="https://www.bigwhite.com/season-passes?utm_source=alluraDirect&utm_medium=alluraUniversal&utm_campaign=alluraUniversal&utm_id=alluraPerk&utm_term=alluraUniversal&utm_content=alluraUniversal" size="large" variant="contained" color="secondary" fullWidth endIcon={<ChevronRightIcon />}>
              Buy Season Pass
            </Button>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box mb={2}>
              <Typography variant="h3" mt={4} mb={1}>
                <CircleBullet>2</CircleBullet> Claim the credit
              </Typography>
              <Typography>Forward the email receipt to alluraDirect and have the credit applied to your guest account within 48 hours.</Typography>
            </Box>
            <Button size="large" variant="contained" color="secondary" fullWidth onClick={onClick} endIcon={<ChevronRightIcon />}>
              Claim the Credit
            </Button>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box mb={2}>
              <Typography variant="h3" mt={4} mb={1}>
                <CircleBullet>3</CircleBullet> Book accommodation
              </Typography>
              <Typography>Search and reserve your Big White vacation rental on alluraDirect for any dates in the Winter season.</Typography>
            </Box>
            <Button size="large" target="_blank" variant="contained" color="secondary" fullWidth href="https://www.alluradirect.com/bigwhite-accommodations.cfm" endIcon={<ChevronRightIcon />}>
              Search Accommodation
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Typography><strong>Note:</strong> The season passholder credit will automatically apply on your next Big White reservation as long as you claim it.  <Link href="/signup" target="_blank" color="secondary">We recommend creating your alluraDirect guest account and claiming this perk today for future usage.</Link></Typography>
          </Grid>
        </Grid>
      </ContentSection>
    </>
  );
};
